// @flow

import React from 'react';
import './applicationInformation.css';

type Props = {
  applicationID: String,
  translate: Function,
  userName: String,
  userPhone: String,
  userEmail: String,
  businessName: String
};

const ApplicationInformation = ({ applicationID, translate, userName, userPhone, userEmail, businessName } : Props) => (
  <div className="js-app-info app-info--container">
    <strong className="app-info--header">{translate('applications.information.header')}</strong>
    <div className="app-info">

      <div className="app-info--row">
        <strong>{translate('applications.information.app_id')}: </strong>
        {applicationID}
      </div>

      {businessName && <div className="app-info--row js-business">
        <strong>{translate('applications.information.business_name')}: </strong>
        {businessName}
      </div>}

      <div className="app-info--row">
        <strong>{translate('applications.information.name')}: </strong>
        {userName}
      </div>

      <div className="app-info--row">
        <strong>{translate('applications.information.phone')}: </strong>
        {userPhone}
      </div>

      <div className="app-info--row">
        <strong>{translate('applications.information.email')}: </strong>
        {userEmail}
      </div>

    </div>
  </div>
);

export default ApplicationInformation;



// WEBPACK FOOTER //
// ./src/components/main/InsuranceInquiry/applicationInformation.js